//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import WorkCreateModule from '../content/tokens/work-create';

import { UserForm } from "../services/srvc-utilities";

export default function AcademicCreate() {

  return (
  <>
    <ContentFormatXX 
      head='Create Academic Credential'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <WorkCreateModule />


        </>
      } 
    />
  </>
  )
}